// extracted by mini-css-extract-plugin
export var brand = "_7i-8";
export var compact = "_7i-5";
export var extraSmall = "_7i-6";
export var icon = "_7i-0";
export var large = "_7i-3";
export var light = "_7i-1";
export var medium = "_7i-4";
export var outline = "_7i-a";
export var primaryDark = "_7i-9";
export var primaryLight = "_7i-7";
export var primaryModern = "_7i-b";
export var success = "_7i-2";